/* eslint-disable react/prop-types */
import { TouchableOpacity, View } from "react-native"
import InfoIcon from "@/assets/icons/tooltip-i-icon.svg"
import BFText from "@/components/standard/BFText"

// For section titles
interface CalculationSectionTitleProps {
  title: string
}

const CalculationSectionTitle: React.FC<CalculationSectionTitleProps> = ({
  title,
}) => {
  return (
    <BFText className="text-lg font-extrabold font-figtree-bold mb-2 text-gray-800">
      {title}
    </BFText>
  )
}

// For field titles with optional tooltip
export interface CalculationFieldProps {
  title: string
  subtitle?: string
  tooltipText?: string
}

const CalculationField: React.FC<CalculationFieldProps> = ({
  title,
  subtitle,
  tooltipText,
}) => {
  const onIconPress = () => {}

  return (
    <View className="relative mt-5 z-10">
      <View className="flex-row items-center">
        <BFText className="text-[15px] font-spacegrotesk font-semibold text-gray-600 leading-[18px]">
          {title}
        </BFText>
        {tooltipText && (
          <TouchableOpacity
            testID={"info-icon-button"}
            onPress={onIconPress}
            className="ml-1"
          >
            <InfoIcon width={16} height={16} />
          </TouchableOpacity>
        )}
      </View>
      <BFText className="text-xs text-gray-500">{subtitle}</BFText>
    </View>
  )
}

export { CalculationSectionTitle, CalculationField }
